const METRIKA_SCRIPT_URL = 'https://mc.yandex.ru/metrika/tag.js'
const INTERACTION_EVENTS = ['scroll', 'pointerdown', 'touchstart', 'keydown'] as const

type YandexMetrika = ((...args: unknown[]) => void) & {
    a?: unknown[][]
    l?: number
}

function createMetrikaQueue(): YandexMetrika {
    const ym: YandexMetrika = (...args: unknown[]) => {
        (ym.a ||= []).push(args)
    }
    ym.l = Date.now()

    return ym
}

export default defineNuxtPlugin(() => {
    const {
        public: { yandexMetrikaId },
    } = useRuntimeConfig()

    if (import.meta.dev || !yandexMetrikaId) {
        return
    }

    if (isPrivateAnalyticsHere() || cameFromPrivateAnalyticsRoute()) {
        return
    }

    const metrikaWindow = window as typeof window & { ym?: YandexMetrika }
    const ym = metrikaWindow.ym ||= createMetrikaQueue()

    ym(yandexMetrikaId, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
        ecommerce: 'dataLayer',
    })

    let loaded = false

    const cleanup = () => {
        for (const eventName of INTERACTION_EVENTS) {
            window.removeEventListener(eventName, loadMetrika)
        }
    }

    const loadMetrika = () => {
        if (loaded) {
            return
        }

        // Счётчик инициализируется один раз, а SPA-переход мог увести на приватный URL уже
        // после инициализации: тянуть скрипт оттуда нельзя.
        if (isPrivateAnalyticsHere()) {
            return
        }

        loaded = true
        cleanup()

        if (document.querySelector(`script[src="${METRIKA_SCRIPT_URL}"]`)) {
            return
        }

        const script = document.createElement('script')
        script.async = true
        script.src = METRIKA_SCRIPT_URL
        document.head.appendChild(script)
    }

    for (const eventName of INTERACTION_EVENTS) {
        window.addEventListener(eventName, loadMetrika, {once: true, passive: true})
    }
})
